import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
	iconPack: 'material' // material|fontawesome
});

Vue.toasted.register('orderCreated', 'Заявка создана!', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('orderisUpdated', 'Заявка обновлена', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('orderDeclined', 'Заявка отменена!', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('orderCanceledFromTk', 'Заявка отозвана!', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('orderDeleted', 'Заявка удалена!', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('templateCreated', 'Шаблон создан!', {
	type: 'success',
	icon: 'check',
	duration: 5000
});


Vue.toasted.register('templateUpdated', 'Шаблон обновлен!', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('templateDeleted', 'Шаблон удален!', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('fileLoaded', 'Файл загружен', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('dateError', 'Укажите дату отправки', {
	type: 'error',
	icon: 'error',
	duration: 5000
});

Vue.toasted.register('fillFields', 'Заполните все необходимые поля', {
	type: 'error',
	icon: 'error',
	duration: 5000
});

Vue.toasted.register('saveChanges', 'Сохраните изменения', {
	type: 'error',
	icon: 'error',
	duration: 5000
});

Vue.toasted.register('carrierAdded',
	() => {
		return 'Новый перевозчик добавлен';
	},
	{
		type: 'success',
		icon: 'check',
		duration: 5000
	});

Vue.toasted.register('carrierChanged',
	'Файл загружен',
	{
		type: 'success',
		icon: 'check',
		duration: 5000
	});

Vue.toasted.register('carrierDeleted',
	carrierName => {
		return `Перевозчик ${carrierName} удален`;
	},
	{
		type: 'success',
		icon: 'check',
		duration: 5000
	});

Vue.toasted.register('rolesUpdated', 'Роли обновлены', {
	type: 'success',
	icon: 'check',
	duration: 5000
});

Vue.toasted.register('roleAdded', 'Роль добавлена', {
	type: 'success',
	icon: 'check',
	duration: 5000
});


Vue.toasted.register('roleChanged', 'Роль изменена', {
	type: 'success',
	icon: 'check',
	duration: 5000
});


Vue.toasted.register('optionsAdded', 'Услуги добавлены', {
	type: 'success',
	icon: 'check',
	duration: 5000
});
